<template>
  <div class="mapa-calor-container">
    <Loading v-if="cargando" />

    <!-- Filtros -->
    <div class="card shadow-sm border-0 mb-3">
      <div class="card-header bg-white border-0">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <span class="badge bg-light text-dark border rounded-pill me-2">
              <i class="fas fa-filter me-1"></i>
              Filtros
            </span>
            <small class="text-muted">Ajusta el rango y el tipo</small>
          </div>
          <span class="badge bg-white text-dark border rounded-pill">
            {{ filtros.fechaInicial }} → {{ filtros.fechaFinal }}
          </span>
        </div>
      </div>
      <div class="card-body">
        <div class="row g-3 justify-content-center">
          <div class="col-12 col-md-3">
            <label class="form-label text-muted small mb-1"
              >Fecha inicial</label
            >
            <div class="input-group input-group-sm">
              <span class="input-group-text bg-white">
                <i class="fas fa-calendar-alt text-muted"></i>
              </span>
              <input
                v-model="filtros.fechaInicial"
                type="date"
                class="form-control"
                :max="filtros.fechaFinal"
              />
            </div>
          </div>

          <div class="col-12 col-md-3">
            <label class="form-label text-muted small mb-1">Fecha final</label>
            <div class="input-group input-group-sm">
              <span class="input-group-text bg-white">
                <i class="fas fa-calendar-alt text-muted"></i>
              </span>
              <input
                v-model="filtros.fechaFinal"
                type="date"
                class="form-control"
                :min="filtros.fechaInicial"
                :max="hoy"
              />
            </div>
          </div>

          <div class="col-12 col-md-3">
            <label class="form-label text-muted small mb-1"
              >Tipo de novedad</label
            >
            <div class="input-group input-group-sm">
              <span class="input-group-text bg-white">
                <i class="fas fa-exclamation-triangle text-muted"></i>
              </span>
              <select
                v-model="filtros.tipoNovedad"
                class="form-select"
                @change="onTipoNovedadChange"
              >
                <option value="">Todos los tipos</option>
                <option
                  v-for="tipo in tiposNovedad"
                  :key="tipo.value"
                  :value="tipo.value"
                >
                  {{ tipo.label }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-12 col-md-3">
            <label class="form-label text-muted small mb-1">Subnovedad</label>
            <div class="input-group input-group-sm">
              <span class="input-group-text bg-white">
                <i class="fas fa-list text-muted"></i>
              </span>
              <select
                v-model="filtros.tipoSubnovedad"
                class="form-select"
                :disabled="!filtros.tipoNovedad || cargandoSubnovedades"
              >
                <option value="">Todas las subnovedades</option>
                <option
                  v-for="sub in subNovedades"
                  :key="sub.value"
                  :value="sub.value"
                >
                  {{ sub.label }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label text-muted small mb-1">Ruta</label>
            <v-select
              v-model="ruta"
              class="form-control form-control-sm p-0"
              :options="listasForms.rutas"
              label="nombre"
              placeholder="Ruta"
              @search="buscarRutas"
              @input="selectRuta()"
              multiple
            ></v-select>
          </div>
        </div>

        <div class="d-flex flex-column flex-md-row gap-2 mt-3">
          <button
            @click="cargarNovedades"
            class="btn btn-primary btn-lg rounded-pill flex-grow-1 shadow-sm"
            :disabled="cargando"
          >
            <i class="fas fa-fire me-2"></i>
            <span v-if="!cargando">Generar Mapa de Calor</span>
            <span v-else>
              <i class="fas fa-spinner fa-spin me-2"></i>
              Cargando...
            </span>
          </button>
          <button
            @click="limpiarFiltros"
            class="btn btn-outline-secondary btn-lg rounded-pill"
            :disabled="cargando"
          >
            <i class="fas fa-eraser me-2"></i>
            Limpiar
          </button>
        </div>

        <!-- Información de resultados -->
        <div v-if="novedades.length > 0" class="mt-3">
          <div
            class="alert alert-info mb-0 d-flex flex-wrap align-items-center gap-2"
          >
            <span class="badge bg-white text-dark border rounded-pill">
              <i class="fas fa-info-circle me-1 text-info"></i>
              {{ novedades.length }} novedades
            </span>
            <span v-if="filtros.tipoNovedad" class="text-muted small">
              Tipo:
              <strong class="text-dark">{{ tipoNovedadSeleccionado }}</strong>
            </span>
            <span v-if="filtros.tipoSubnovedad" class="text-muted small">
              Subnovedad:
              <strong class="text-dark">{{ subNovedadSeleccionada }}</strong>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Mapa -->
    <div class="card shadow-sm border-0">
      <div class="card-header bg-white border-0">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <span
              class="badge bg-primary bg-opacity-10 text-primary border rounded-pill me-2"
            >
              <i class="fas fa-map-marked-alt me-1"></i>
              Mapa
            </span>
            <small class="text-muted">Concentración de novedades</small>
          </div>
          <span class="badge bg-white text-dark border rounded-pill">
            {{ novedades.length }} puntos
          </span>
        </div>
      </div>
      <div class="card-body p-0">
        <div
          id="mapaCalor"
          ref="mapaCalor"
          style="height: 650px; width: 100%"
        ></div>
      </div>

      <!-- Leyenda del Mapa de Calor -->
      <div class="card-footer bg-white border-0">
        <div
          class="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2"
        >
          <div class="d-flex align-items-center flex-wrap gap-2">
            <span class="badge bg-light text-dark border rounded-pill">
              <i class="fas fa-fire me-1 text-danger"></i>
              Intensidad
            </span>
            <span class="badge bg-success rounded-pill">Baja</span>
            <div class="gradient-bar mx-1"></div>
            <span class="badge bg-danger rounded-pill">Alta</span>
          </div>
          <small class="text-muted"
            >Refina la visualización con los controles</small
          >
        </div>

        <!-- Controles del mapa de calor -->
        <div class="row g-3 mt-2">
          <div class="col-12 col-md-6">
            <div class="d-flex justify-content-between align-items-center">
              <span class="text-muted small">Radio de influencia</span>
              <span class="badge bg-white text-dark border rounded-pill">
                {{ heatmapConfig.radius }}px
              </span>
            </div>
            <input
              v-model="heatmapConfig.radius"
              type="range"
              min="10"
              max="50"
              class="form-range"
              @input="actualizarHeatmap"
            />
          </div>
          <div class="col-12 col-md-6">
            <div class="d-flex justify-content-between align-items-center">
              <span class="text-muted small">Opacidad</span>
              <span class="badge bg-white text-dark border rounded-pill">
                {{ Math.round(heatmapConfig.opacity * 100) }}%
              </span>
            </div>
            <input
              v-model="heatmapConfig.opacity"
              type="range"
              min="0"
              max="1"
              step="0.1"
              class="form-range"
              @input="actualizarHeatmap"
            />
          </div>
        </div>

        <!-- Capas del mapa -->
        <div class="d-flex flex-wrap gap-2 mt-3">
          <label
            class="btn btn-outline-secondary btn-sm rounded-pill px-3"
            :class="{ 'btn-secondary text-white': capasMapa.geocercas }"
          >
            <input
              type="checkbox"
              class="d-none"
              v-model="capasMapa.geocercas"
              @change="toggleGeocercas"
              :disabled="capasCargando.geocercas"
            />
            <span v-if="capasCargando.geocercas">
              <span
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              Cargando...
            </span>
            <span v-else>
              <i class="fas fa-draw-polygon me-1"></i>
              Geocercas
            </span>
          </label>

          <label
            class="btn btn-outline-warning btn-sm rounded-pill px-3"
            :class="{ 'btn-warning text-dark': capasMapa.campos }"
          >
            <input
              type="checkbox"
              class="d-none"
              v-model="capasMapa.campos"
              @change="toggleCampos"
              :disabled="capasCargando.campos"
            />
            <span v-if="capasCargando.campos">
              <span
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              Cargando...
            </span>
            <span v-else>
              <i class="fas fa-layer-group me-1"></i>
              Campos
            </span>
          </label>

          <label
            class="btn btn-outline-info btn-sm rounded-pill px-3"
            :class="{ 'btn-info text-white': capasMapa.rutas }"
          >
            <input
              type="checkbox"
              class="d-none"
              v-model="capasMapa.rutas"
              @change="toggleRutas"
              :disabled="capasCargando.rutas"
            />
            <span v-if="capasCargando.rutas">
              <span
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              Cargando...
            </span>
            <span v-else>
              <i class="fas fa-route me-1"></i>
              Rutas
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import Loading from "@/components/Loading";
import { crearMapaCalor } from "@/utils/mapaCalorOverlay";

// Se asigna cuando la API de Google Maps termina de cargar, no al evaluar el módulo
let google = null;

export default {
  name: "MapaCalorNovedades",
  components: {
    Loading,
    vSelect,
  },
  data() {
    const hoy = new Date();
    const hace7Dias = new Date();
    hace7Dias.setDate(hoy.getDate() - 7);

    return {
      cargando: false,
      cargandoSubnovedades: false,
      hoy: hoy.toISOString().split("T")[0],
      filtros: {
        fechaInicial: hace7Dias.toISOString().split("T")[0],
        fechaFinal: hoy.toISOString().split("T")[0],
        tipoNovedad: "",
        tipoSubnovedad: "",
        ruta_id: null,
      },
      ruta: [],
      novedades: [],
      tiposNovedad: [],
      subNovedades: [],
      mapa: null,
      heatmap: null,
      heatmapConfig: {
        radius: 25,
        opacity: 0.6,
      },
      capasMapa: {
        geocercas: false,
        campos: false,
        rutas: false,
      },
      capasCargando: {
        geocercas: false,
        campos: false,
        rutas: false,
      },
      capasCache: {
        geocercas: null,
        campos: null,
        rutas: null,
      },
      capasOverlays: {
        geocercas: { poligonos: [], circulos: [] },
        campos: { poligonos: [], circulos: [] },
        rutas: { polilineas: [] },
      },
      listasForms: {
        rutas: [],
      },
      infoWindow: null,
    };
  },
  computed: {
    tipoNovedadSeleccionado() {
      if (!this.filtros.tipoNovedad) return "";
      const tipo = this.tiposNovedad.find(
        (t) => t.value == this.filtros.tipoNovedad,
      );
      return tipo ? tipo.label : "";
    },
    subNovedadSeleccionada() {
      if (!this.filtros.tipoSubnovedad) return "";
      const sub = this.subNovedades.find(
        (s) => s.value == this.filtros.tipoSubnovedad,
      );
      return sub ? sub.label : "";
    },
  },
  mounted() {
    this.esperarGoogleMaps();
    this.cargarTiposNovedad();
  },
  beforeUnmount() {
    // Limpiar el mapa cuando el componente se destruya
    if (this.heatmap) {
      this.heatmap.setMap(null);
    }
    this.limpiarCapas();
    if (this.mapa) {
      this.mapa = null;
    }
  },
  methods: {
    async esperarGoogleMaps() {
      // Dispara la carga de la API si aún no ha empezado
      if (this.$gmapApiPromiseLazy) {
        await this.$gmapApiPromiseLazy();
      }

      // Esperar a que Google Maps esté cargado completamente
      const checkGoogleMaps = () => {
        if (
          window.google &&
          window.google.maps &&
          window.google.maps.OverlayView
        ) {
          google = window.google;
          this.inicializarMapa();
          this.cargarNovedades();
        } else {
          setTimeout(checkGoogleMaps, 100);
        }
      };
      checkGoogleMaps();
    },

    inicializarMapa() {
      // Inicializar mapa centrado en Colombia
      const centroMapa = { lat: 4.570868, lng: -74.297333 };

      this.mapa = new google.maps.Map(this.$refs.mapaCalor, {
        center: centroMapa,
        zoom: 6,
        mapTypeId: "roadmap",
        mapTypeControl: true,
        streetViewControl: false,
        fullscreenControl: true,
        zoomControl: true,
      });
    },

    asegurarInfoWindow() {
      if (!this.infoWindow) {
        this.infoWindow = new google.maps.InfoWindow();
      }
    },

    mostrarInfoWindow(contenido, posicion) {
      if (!this.mapa || !posicion) return;
      this.asegurarInfoWindow();
      this.infoWindow.setContent(contenido || "");
      this.infoWindow.setPosition(posicion);
      this.infoWindow.open(this.mapa);
    },

    async cargarTiposNovedad() {
      try {
        const response = await axios.get(
          "/api/admin/centralTrafico/tiposNovedadesMapaCalor",
        );
        this.tiposNovedad = response.data.data || [];
      } catch (error) {
        console.error("Error al cargar tipos de novedad:", error);
      }
    },

    async cargarSubNovedades() {
      if (!this.filtros.tipoNovedad) {
        this.subNovedades = [];
        return;
      }

      this.cargandoSubnovedades = true;

      try {
        const response = await axios.get(
          "/api/admin/centralTrafico/subNovedadesMapaCalor",
          {
            params: {
              tipo_novedad: this.filtros.tipoNovedad,
            },
          },
        );
        this.subNovedades = response.data.data || [];
      } catch (error) {
        console.error("Error al cargar subnovedades:", error);
        this.subNovedades = [];
      } finally {
        this.cargandoSubnovedades = false;
      }
    },

    onTipoNovedadChange() {
      // Limpiar subnovedad cuando cambia el tipo
      this.filtros.tipoSubnovedad = "";
      this.subNovedades = [];

      // Cargar subnovedades del nuevo tipo
      if (this.filtros.tipoNovedad) {
        this.cargarSubNovedades();
      }
    },

    async cargarNovedades() {
      if (!this.filtros.fechaInicial || !this.filtros.fechaFinal) {
        this.$swal({
          icon: "warning",
          title: "Atención",
          text: "Por favor selecciona ambas fechas",
        });
        return;
      }

      this.cargando = true;

      try {
        const params = {
          fecha_inicial: this.filtros.fechaInicial,
          fecha_final: this.filtros.fechaFinal,
        };

        // Agregar filtros opcionales si están seleccionados
        if (this.filtros.tipoNovedad) {
          params.tipo_novedad = this.filtros.tipoNovedad;
        }

        if (this.filtros.tipoSubnovedad) {
          params.tipo_subnovedad = this.filtros.tipoSubnovedad;
        }

        const response = await axios.get(
          "/api/admin/centralTrafico/novedadesMapaCalor",
          {
            params: params,
          },
        );

        this.novedades = response.data.data || [];
        this.generarMapaCalor();

        if (this.novedades.length === 0) {
          this.$swal({
            icon: "info",
            title: "Sin resultados",
            text: "No se encontraron novedades con los filtros seleccionados",
          });
        }
      } catch (error) {
        console.error("Error al cargar novedades:", error);
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Error al cargar las novedades para el mapa de calor",
        });
      } finally {
        this.cargando = false;
      }
    },

    generarMapaCalor() {
      // Limpiar heatmap anterior si existe
      if (this.heatmap) {
        this.heatmap.setMap(null);
      }

      // Preparar datos para el heatmap
      const heatmapData = [];
      let bounds = new google.maps.LatLngBounds();

      this.novedades.forEach((novedad) => {
        if (novedad.latitud && novedad.longitud) {
          const location = new google.maps.LatLng(
            parseFloat(novedad.latitud),
            parseFloat(novedad.longitud),
          );

          // Asignar peso según el tipo de novedad y relevancia
          let weight = 1;

          // Asignar peso según relevancia
          // relevancia 2 = Emergencia (impactos, botón emergencia)
          // relevancia 1 = Advertencia (excesos velocidad, frenadas, etc)
          if (novedad.relevancia === 2) {
            weight = 10; // Emergencias - Mayor peso
          } else if (novedad.relevancia === 1) {
            weight = 5; // Advertencias - Peso medio
          } else if (novedad.tipo_subnovedad) {
            weight = 3; // Otras novedades específicas
          }

          heatmapData.push({
            location: location,
            weight: weight,
          });

          bounds.extend(location);
        }
      });

      // Crear capa de mapa de calor
      if (heatmapData.length > 0) {
        this.heatmap = crearMapaCalor(google, {
          data: heatmapData,
          map: this.mapa,
          radius: this.heatmapConfig.radius,
          opacity: this.heatmapConfig.opacity,
          gradient: [
            "rgba(0, 255, 0, 0)",
            "rgba(0, 255, 0, 1)",
            "rgba(85, 255, 0, 1)",
            "rgba(170, 255, 0, 1)",
            "rgba(255, 255, 0, 1)",
            "rgba(255, 213, 0, 1)",
            "rgba(255, 170, 0, 1)",
            "rgba(255, 128, 0, 1)",
            "rgba(255, 85, 0, 1)",
            "rgba(255, 43, 0, 1)",
            "rgba(255, 0, 0, 1)",
          ],
        });

        // Ajustar el mapa para mostrar todos los puntos
        this.mapa.fitBounds(bounds);

        // Si solo hay un punto, hacer zoom apropiado
        if (heatmapData.length === 1) {
          this.mapa.setZoom(12);
        }
      } else {
        // Si no hay datos, volver a centrar en Colombia
        this.mapa.setCenter({ lat: 4.570868, lng: -74.297333 });
        this.mapa.setZoom(6);
      }
    },

    actualizarHeatmap() {
      if (this.heatmap) {
        this.heatmap.setOptions({
          radius: parseInt(this.heatmapConfig.radius),
          opacity: parseFloat(this.heatmapConfig.opacity),
        });
      }
    },

    limpiarFiltros() {
      const hoy = new Date();
      const hace7Dias = new Date();
      hace7Dias.setDate(hoy.getDate() - 7);

      this.filtros = {
        fechaInicial: hace7Dias.toISOString().split("T")[0],
        fechaFinal: hoy.toISOString().split("T")[0],
        tipoNovedad: "",
        tipoSubnovedad: "",
        ruta_id: null,
      };
      this.ruta = [];
      this.listasForms.rutas = [];

      this.subNovedades = [];
      this.novedades = [];

      // Limpiar mapa de calor
      if (this.heatmap) {
        this.heatmap.setMap(null);
      }

      // Recentrar mapa
      if (this.mapa) {
        this.mapa.setCenter({ lat: 4.570868, lng: -74.297333 });
        this.mapa.setZoom(6);
      }
    },

    toggleGeocercas() {
      if (this.capasMapa.geocercas) {
        this.cargarGeocercas();
      } else {
        this.limpiarCapaGeocercas();
      }
    },

    toggleCampos() {
      if (this.capasMapa.campos) {
        this.cargarCampos();
      } else {
        this.limpiarCapaCampos();
      }
    },

    toggleRutas() {
      if (this.capasMapa.rutas) {
        this.cargarRutas();
      } else {
        this.limpiarCapaRutas();
      }
    },

    limpiarCapas() {
      this.limpiarCapaGeocercas();
      this.limpiarCapaCampos();
      this.limpiarCapaRutas();
    },

    limpiarOverlays(lista) {
      lista.forEach((overlay) => {
        overlay.setMap(null);
      });
      lista.length = 0;
    },

    limpiarCapaGeocercas() {
      this.limpiarOverlays(this.capasOverlays.geocercas.poligonos);
      this.limpiarOverlays(this.capasOverlays.geocercas.circulos);
    },

    limpiarCapaCampos() {
      this.limpiarOverlays(this.capasOverlays.campos.poligonos);
      this.limpiarOverlays(this.capasOverlays.campos.circulos);
    },

    limpiarCapaRutas() {
      this.limpiarOverlays(this.capasOverlays.rutas.polilineas);
    },

    async cargarGeocercas() {
      if (!this.mapa) return;
      if (this.capasCache.geocercas) {
        this.dibujarGeocercas(this.capasCache.geocercas);
        return;
      }

      this.capasCargando.geocercas = true;
      try {
        const response = await axios.get(
          "/api/hidrocarburos/mapas/showGeocercas",
        );
        const data = response.data?.gps_fin || {};
        this.capasCache.geocercas = data;
        this.dibujarGeocercas(data);
      } catch (error) {
        console.error("Error al cargar geocercas:", error);
        this.capasMapa.geocercas = false;
      } finally {
        this.capasCargando.geocercas = false;
      }
    },

    dibujarGeocercas(data) {
      this.limpiarCapaGeocercas();
      const poligonales = data.geocerca_poli || [];
      const circulares = data.geocerca_cir || [];

      poligonales.forEach((geocerca) => {
        if (!geocerca.puntos || geocerca.puntos.length === 0) return;
        const path = geocerca.puntos
          .map((punto) => ({
            lat: parseFloat(punto.latitud),
            lng: parseFloat(punto.longitud),
          }))
          .filter((p) => !Number.isNaN(p.lat) && !Number.isNaN(p.lng));

        if (path.length === 0) return;

        const polygon = new google.maps.Polygon({
          paths: path,
          strokeColor: geocerca.color || "#dc2626",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: geocerca.color || "#dc2626",
          fillOpacity: 0.2,
          map: this.mapa,
        });

        polygon.addListener("click", () => {
          this.mostrarInfoWindow(geocerca.ventana, path[0]);
        });

        this.capasOverlays.geocercas.poligonos.push(polygon);
      });

      circulares.forEach((geocerca) => {
        const lat = parseFloat(geocerca.lat);
        const lng = parseFloat(geocerca.lon);
        const radius = parseFloat(geocerca.radio);

        if (Number.isNaN(lat) || Number.isNaN(lng) || Number.isNaN(radius)) {
          return;
        }

        const circle = new google.maps.Circle({
          center: { lat, lng },
          radius: radius,
          strokeColor: geocerca.color || "#dc2626",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: geocerca.color || "#dc2626",
          fillOpacity: 0.2,
          map: this.mapa,
        });

        circle.addListener("click", () => {
          this.mostrarInfoWindow(geocerca.ventana, { lat, lng });
        });

        this.capasOverlays.geocercas.circulos.push(circle);
      });
    },

    async cargarCampos() {
      if (!this.mapa) return;
      if (this.capasCache.campos) {
        this.dibujarCampos(this.capasCache.campos);
        return;
      }

      this.capasCargando.campos = true;
      try {
        const response = await axios.get(
          "/api/hidrocarburos/mapas/showGeocercasProhibidas",
        );
        const data = response.data?.gps_fin || {};
        this.capasCache.campos = data;
        this.dibujarCampos(data);
      } catch (error) {
        console.error("Error al cargar campos:", error);
        this.capasMapa.campos = false;
      } finally {
        this.capasCargando.campos = false;
      }
    },

    dibujarCampos(data) {
      this.limpiarCapaCampos();
      const poligonales = data.geocerca_poli || [];
      const circulares = data.geocerca_cir || [];

      poligonales.forEach((campo) => {
        if (!campo.puntos || campo.puntos.length === 0) return;
        const path = campo.puntos
          .map((punto) => ({
            lat: parseFloat(punto.latitud),
            lng: parseFloat(punto.longitud),
          }))
          .filter((p) => !Number.isNaN(p.lat) && !Number.isNaN(p.lng));

        if (path.length === 0) return;

        const polygon = new google.maps.Polygon({
          paths: path,
          strokeColor: campo.color || "#f59e0b",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: campo.color || "#f59e0b",
          fillOpacity: 0.2,
          map: this.mapa,
        });

        polygon.addListener("click", () => {
          this.mostrarInfoWindow(campo.ventana, path[0]);
        });

        this.capasOverlays.campos.poligonos.push(polygon);
      });

      circulares.forEach((campo) => {
        const lat = parseFloat(campo.lat);
        const lng = parseFloat(campo.lon);
        const radius = parseFloat(campo.radio);

        if (Number.isNaN(lat) || Number.isNaN(lng) || Number.isNaN(radius)) {
          return;
        }

        const circle = new google.maps.Circle({
          center: { lat, lng },
          radius: radius,
          strokeColor: campo.color || "#f59e0b",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: campo.color || "#f59e0b",
          fillOpacity: 0.2,
          map: this.mapa,
        });

        circle.addListener("click", () => {
          this.mostrarInfoWindow(campo.ventana, { lat, lng });
        });

        this.capasOverlays.campos.circulos.push(circle);
      });
    },

    async cargarRutas() {
      if (!this.mapa) return;
      if (this.capasCache.rutas && !this.filtros.ruta_id) {
        this.dibujarRutasPorTramos(this.capasCache.rutas);
        return;
      }

      this.capasCargando.rutas = true;
      try {
        const rutasResponse = await axios.get(
          "/api/admin/centralTrafico/rutasTramosMapaCalor",
          {
            params: {
              ruta_id: this.filtros.ruta_id,
            },
          },
        );
        const rutas = rutasResponse.data?.data || [];
        this.capasCache.rutas = rutas;
        this.dibujarRutasPorTramos(rutas);
      } catch (error) {
        console.error("Error al cargar rutas:", error);
        this.capasMapa.rutas = false;
      } finally {
        this.capasCargando.rutas = false;
      }
    },

    buscarRutas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url =
          "/api/admin/centralTrafico/rutasTramosMapaCalor?nombre=" + search;
        axios
          .get(url)
          .then(function(response) {
            me.listasForms.rutas = response.data.data;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },

    selectRuta() {
      this.filtros.ruta_id = this.ruta.map((r) => r.id);
      this.cargarRutas();
    },

    dibujarRutasPorTramos(rutas) {
      this.limpiarCapaRutas();

      rutas.forEach((ruta) => {
        const tramosRuta = ruta.rutas_tramos || [];

        tramosRuta.forEach((rutaTramo) => {
          const tramo = rutaTramo.tramo_ruta;
          if (!tramo || !tramo.det_tramos_rutas) return;

          const detallesOrdenados = [...tramo.det_tramos_rutas].sort((a, b) => {
            return (a.orden || 0) - (b.orden || 0);
          });

          const path = [];
          detallesOrdenados.forEach((detalle, index) => {
            const latIni = parseFloat(detalle.lat_ini);
            const lngIni = parseFloat(detalle.lon_ini);
            const latFin = parseFloat(detalle.lat_fin);
            const lngFin = parseFloat(detalle.lon_fin);

            if (
              Number.isNaN(latIni) ||
              Number.isNaN(lngIni) ||
              Number.isNaN(latFin) ||
              Number.isNaN(lngFin)
            ) {
              return;
            }

            if (index === 0) {
              path.push({ lat: latIni, lng: lngIni });
            }
            path.push({ lat: latFin, lng: lngFin });
          });

          if (path.length < 2) return;

          const polyline = new google.maps.Polyline({
            path,
            strokeColor: tramo.color || "#2563eb",
            strokeOpacity: 0.85,
            strokeWeight: 5,
            map: this.mapa,
          });

          polyline.addListener("click", () => {
            const nombreRuta = ruta.nombre || "Ruta";
            const nombreTramo = tramo.nombre || "Tramo";
            this.mostrarInfoWindow(
              `<div style="padding: 6px;">
                <strong>${nombreRuta}</strong><br>
                <span>${nombreTramo}</span>
              </div>`,
              path[0],
            );
          });

          this.capasOverlays.rutas.polilineas.push(polyline);
        });
      });
    },
  },
};
</script>

<style scoped>
.mapa-calor-container {
  padding: 0;
}

.gradient-bar {
  width: 100px;
  height: 20px;
  background: linear-gradient(to right, #00ff00, #ffff00, #ff0000);
  border-radius: 4px;
  border: 1px solid #ddd;
}

.form-range {
  cursor: pointer;
}

.form-range::-webkit-slider-thumb {
  background: #007bff;
}

.form-range::-moz-range-thumb {
  background: #007bff;
}

.alert-info {
  border-left: 4px solid #17a2b8;
}
</style>
